import React from 'react';
import { vodExpiryCountdown, type VodExpiryInput } from '../utils/vodExpiry';

type StudioVodExpiryProps = {
  vod: VodExpiryInput;
  className?: string;
};

const StudioVodExpiry: React.FC<StudioVodExpiryProps> = ({ vod, className }) => {
  const countdown = vodExpiryCountdown(vod);
  if (!countdown) return null;
  return (
    <p
      className={`studio-vod-expiry ${countdown.urgent ? 'is-urgent' : ''} ${
        className ?? ''
      }`.trim()}
      data-testid="studio-vod-expiry"
    >
      <span aria-hidden>⏳ </span>
      {countdown.label}
    </p>
  );
};

export default StudioVodExpiry;
